import { Component, Input, OnChanges } from '@angular/core';
import { StoreTemplateStatus } from '@pt/pt-models';

@Component({
  selector: 'pt-template-complete-status',
  template: `
    <div class="mb-2 mt-4">
      <p class="mb-0">{{'LABELS.COMPLETE_STATUS' | translate}} {{validWidget}}/{{totalWidget}}
      </p>
      <ngb-progressbar type="success"
                       [value]="completeStatus()"
                       height="3px">
      </ngb-progressbar>
    </div>

  `
})
export class TemplateCompleteStatusComponent implements OnChanges {

  @Input() status: StoreTemplateStatus;
  totalWidget = 0;
  validWidget = 0;

  completeStatus() {
    if (this.totalWidget && this.validWidget) {
      return Math.floor((100 / this.totalWidget) * this.validWidget);
    }
    return 0;
  }

  ngOnChanges(): void {
    if (this.status) {
      this.totalWidget = this.status.totalWidget;
      this.validWidget = this.status.validWidgetId?.length;
    } else {
      this.totalWidget = 0;
      this.validWidget = 0;
    }
  }
}
